module.exports = __webpack_public_path__ + "img/how-to-install-fmwhatsapp.337d6209.webp";